 // import React from 'react';
// import React, { useRef } from 'react';

import React, { useEffect, useRef, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import custfocus333 from "../assets/img/update_2/icon/custfocus333.jpg";
import custfocus444 from "../assets/img/update_2/icon/custfocus444.png";
// import quality333 from "../assets/img/update_2/icon/quality333.jpg";
// import techdriven333 from "../assets/img/update_2/icon/techdriven333.jpg";
// import backint333 from "../assets/img/update_2/icon/backint333.jpg";





import quality444 from "../assets/img/update_2/icon/quality444.png";
import techdriven444 from "../assets/img/update_2/icon/techdriven444.png";
import backint444 from "../assets/img/update_2/icon/backint444.png";


// import frozenseafood from "../assets/img/frozenseafoodbanner.png";
// import thirdslider from "../assets/img/Third slider 3.png";
// import frozenpatupdated from "../assets/img/frozenpatupdated.png";
// import feature_bg_5 from "../assets/img/update_2/bg/feature_bg_5.png"
import feature_bg_51 from "../assets/img/update_2/bg/feature_bg_51.jpg"

// import Seafood1 from "../assests/img/SliderImages/Seafood1.jpg";
// import frenchfries from "../assests/img/SliderImages/yum-banner-1.jpg";
import frenchfries from "../assests/img/SliderImages/yum-banner-1.png";
// import Seafood4 from "../assests/img/SliderImages/Seafood4.jpg";
import potatoeswedges from "../assests/img/SliderImages/yum-banner-2.jpg";


import dishround from "../assets/img/update_2/normal/rightbowl.png";
import roundpotato from "../assets/img/update_2/normal/frenchfries.png";
// import certifications6 from "../assets/img/certifications7.png";
// import certifications4 from "../assets/img/certifications8.png";
// import certificationsSINGLE from "../assets/img/certificationsSINGLE.png";
import testicardimg from "../assets/img/update_2/normal/bigbowl.png";
import testicardshape from "../assets/img/update_2/normal/testi-card_shape_1.png";
import testicardshapeimg from "../assets/img/update_2/normal/testi-card_shape_2.png";
import '../assets/css/style.css';
import '../assets/css/style.css.map';
import '../assets/css/slick.min.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from './footer';


import HoverBoxGrid from '../components/HoverBoxGrid';


import s1 from "../assets/img/update_2/normal/s1.png";
import s2 from "../assets/img/update_2/normal/s2.png";
import s3 from "../assets/img/update_2/normal/s3.png";
import s4 from "../assets/img/update_2/normal/s4.png";
import s5 from "../assets/img/update_2/normal/s5.png";
import s6 from "../assets/img/update_2/normal/s6.png";
import s7 from "../assets/img/update_2/normal/s7.png";
import s8 from "../assets/img/update_2/normal/s8.png";

import c1 from "../assets/img/update_2/certificates/c1.png";
import c2 from "../assets/img/update_2/certificates/c2.png";
import c3 from "../assets/img/update_2/certificates/c3.png";
import c4 from "../assets/img/update_2/certificates/c4.png";
import c5 from "../assets/img/update_2/certificates/c5.png";
import c6 from "../assets/img/update_2/certificates/c6.png";


const SliderImg = [ s1, s2, s3, s4, s5, s6, s7, s8 ];
const CertificatImg = [ c1, c2, c3, c4, c5, c6 ];



const Homepage = ({ history }) => {
      
    const [showQualityDriven, setShowQualityDriven] = useState(false);

    const handleClick = () => {
        setShowQualityDriven(true);
    };
    const [showModal, setShowModal] = useState(false);


    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500, // Change this value for faster or slower speed
        prevArrow: <></>,
        nextArrow: <></>,
        appendDots: dots => (
            <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#F0B323' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };
    
    const settingstwice = {
        // dots: true,
        // infinite: true,
        // speed: 1000,
        // slidesToShow: 1,
        // slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 2500, // Change this value for faster or slower speed

        // appendDots: dots => (
        //     <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
        //         {dots.map((dot, index) => (
        //             <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
        //                 <div
        //                     style={{
        //                         width: '10px',
        //                         height: '10px',
        //                         borderRadius: '50%',
        //                         background: index === dot.props.current ? '#F0B323' : '#fff', // Red for active dot, white for others
        //                         border: '0px solid #333', // Customize the border color
        //                         cursor: 'pointer',
        //                         marginTop: '20px',
        //                     }}
        //                 />
        //             </li>
        //         ))}
        //     </ul>
        // )
    };
    const settingstestimonal = {
        // dots: true,
        // infinite: true,
        // speed: 600,
        // slidesToShow: 1,
        // slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 5000,
        // prevArrow: <></>,
        // nextArrow: <></>,
        // appendDots: dots => (
        //     <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
        //         {dots.map((dot, index) => (
        //             <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
        //                 <div
        //                     style={{
        //                         width: '10px',
        //                         height: '10px',
        //                         borderRadius: '50%',
        //                         background: index === dot.props.current ? '#ff0000' : 'red', // Red for active dot, white for others
        //                         border: '0px solid #333', // Customize the border color
        //                         cursor: 'pointer',
        //                         marginTop: '20px',
        //                     }}
        //                 />
        //             </li>
        //         ))}
        //     </ul>
        // )
    };
    const settingsscroll = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: <></>,
        nextArrow: <></>, 
  responsive: [
    {
      breakpoint: 1024, // screen width <= 1024px
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 768, // screen width <= 768px
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480, // screen width <= 480px
      settings: {
        slidesToShow: 1,
      }
    }
  ],                
        appendDots: dots => (
            // <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
            <ul style={{ display: 'none', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#ff0000' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };
    const settingsscroll11 = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: <></>,
        nextArrow: <></>, 
  responsive: [
    {
      breakpoint: 1024, // screen width <= 1024px
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 768, // screen width <= 768px
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480, // screen width <= 480px
      settings: {
        slidesToShow: 1,
      }
    }
  ],               
        appendDots: dots => (
            // <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
            <ul style={{ display: 'none', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#ff0000' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };    
    const styles = {
        // textAlign: 'left',
        // fontStyle: 'normal',
        // textDecoration: 'none',
        // textTransform: 'none',
        // letterSpacing: '0px',
        // backgroundPosition: '0% 0%',
        // backgroundRepeat: 'no-repeat',
        // fontFamily: 'Rubik',
        // lineHeight: '54px',
        // top: '259px',
        // left: '15px',
        // color: '#010f1c',
        // fontWeight: '800',
        // fontSize: '44px',
        // whiteSpace: 'normal'
      };
    return (

        <div>
         <div className="d-md-block hidearrow">
                <Slider {...settings}>
                    {/* <img
                        width="2000"
                        height="700"
                        src={Seafood1}
                        className="ls-l ls-img-layer"
                        alt="Frozen Seafood"
                        decoding="async"
                        style={{
                            position: 'absolute',
                            left: '0px',
                            top: '107px',
                        }}
                        data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                    /> */}

                    <img
                        width="2000"
                        height="700"
                        src={frenchfries}
                        className="ls-l ls-img-layer"
                        alt="Frozen Potatoes"
                        decoding="async"
                        style={{
                            position: 'absolute',
                            left: '0px',
                            top: '107px',
                        }}
                        data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                    />
            {/* 
                    <img
                        width="2000"
                        height="700"
                        src={Seafood4}
                        className="ls-l ls-img-layer"
                        alt="Heritage Banner"
                        decoding="async"
                        style={{
                            position: 'absolute',
                            left: '0px',
                            top: '107px',
                        }}
                        data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                    /> */}
                    <img
                        width="2000"
                        height="700"
                        src={potatoeswedges}
                        className="ls-l ls-img-layer"
                        alt="Heritage Banner"
                        decoding="async"
                        style={{
                            position: 'absolute',
                            left: '0px',
                            top: '107px',
                        }}
                        data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                    />
                </Slider>
            </div>

 
           
            <br />
            <div class="about-sec overflow-hidden pb-5">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-7 order-2 order-xl-1 mt- mt-xl-0">
                            <div class="testi-card-img">
                                <div class="img1">
                                    <img src={testicardimg} alt="Image" />
                                </div>
                                <div class="shape1">
                                    <img src={testicardshape} alt="Image" />
                                </div>
                                <div class="shape2">
                                    <img src={testicardshapeimg} alt="Image" />
                                </div>
                                <div class="shape3">
                                    <img src={dishround} alt="Image" />
                                </div>
                                <div class="shape44x">
                                    <img src={roundpotato} alt="Image" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5 order-1 order-xl-2" style={{ marginTop: "66px" }}>
                            <div class="title-area mb-30 text-center text-xl-start">
                                <span class="sub-title" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>Frozen French Fries manufacturer in India</span></span>
                                <h2 class="" style={{ fontFamily:'helvetica',color:'#0f1138 !important'}}>
                                    YUMWAY’S NATURALLY CRISPY STORY</h2>
                            </div>
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                            With over 220 years of heritage, YUMWAY is one of India’s most trusted names in natural frozen foods. Born in 1805 from traditional preservation techniques, we’ve evolved into a global brand delivering preservative-free, 
                            </p>
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                            From golden French fries and hearty wedges to burger patties and more, every YUMWAY product is crafted with care-naturally textured, crisp, and ready in just 3 minutes.
                            </p>
                            <p class="mt-n2 mb-25 text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                           YUMWAY isn’t just about food. It’s about preserving the moments that matter-mealtime giggles, shared stories, and the joy of being at the table. YUMWAY means love and care—always.  
                            </p>                                                        
                            <div class="checklist style4 mb-25" style={{ fontFamily:'helvetica' }}>
                                <ul>
                                    <li>Quality Assurance</li>
                                    <li>Heritage and Legacy</li>
                                    <li>Diverse Product Line</li>
                                    <li>Established Compliance</li>
                                </ul>
                            </div>
    

                            <div className="text-center text-xl-start" style={{ fontFamily:'helvetica' }}>
                                <Link to="/about" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>See Details<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <section class="space-extra bg-auto-repeat bg-title" data-bg-src={feature_bg_5} style={{ backgroundImage: `url(${feature_bg_5})`, position: 'relative', top: '27px' }}>
                <div class="container">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ padding: '20px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    <img src="assets/img/update_2/icon/feature_3_1.svg" alt="Food" />
                                </div>
                                <h3 class="food-feature_title box-title text-center">Quality driven</h3>
                                <p class="food-feature_text">

                                    IDG’s primary objective in any field of business is to provide our customers with safe and
                                    reliable product adhering to the food safety norms and policy as per the guidelines of the
                                    statutory authorities and internal quality policy formulated by the company.
                                </p>
                                <br />
                                <Link to="/Idgnew/about" className="th-btn rounded-2">
                                    Read MORE
                                    <i className="fa-solid fa-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ padding: '20px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    <img src="assets/img/update_2/icon/feature_3_2.svg" alt="Food" />
                                </div>
                                <h3 class="food-feature_title box-title">Customer Focus </h3>
                                <p class="food-feature_text">

                                    IDG has always had a customer centric approach towards all its activities and businesses.

                                    Our orientation is always focused on customer satisfaction of the highest order
                                    we aim to cultivate loyalty and long-term partnerships with our customers.
                                </p>
                                <br />
                                <Link to="/Idgnew/about" className="th-btn rounded-2">
                                    Read MORE
                                    <i className="fa-solid fa-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ padding: '20px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    <img src="assets/img/update_2/icon/feature_3_3.svg" alt="Food" />
                                </div>
                                <h3 class="food-feature_title box-title">Technology Driven</h3>
                                <p class="food-feature_text">

                                    IDG has an extensive network of farmers under its wings which help in procurement of all
                                    types
                                    of shrimps and seafood from India.

                                    Wild caught or cultured we are capable and confident enough to provide best quality material
                                    at
                                    the cheapest possible prices.
                                </p>
                                <br />
                                <Link to="/Idgnew/about" className="th-btn rounded-2">
                                    Read MORE
                                    <i className="fa-solid fa-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ padding: '20px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    <img src="assets/img/update_2/icon/feature_3_3.svg" alt="Food" />
                                </div>

                                <h3 className="food-feature_title box-title" style={{
                                    whiteSpace: '',
                                    '@media (max-width: 768px)': { whiteSpace: 'normal' }
                                }}>Backward Integration</h3>


                                <p class="food-feature_text">

                                    IDG employs backward integration to ensure quality in every step of the shrimp and seafood production process. By owning or controlling suppliers, distributors, and retail locations, IDG provides high-quality products to customers at competitive prices.
                                </p>
                                <br />
                                <Link to="/Idgnew/about" className="th-btn rounded-2">
                                    Read MORE
                                    <i className="fa-solid fa-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>



            </section> */}
            <HoverBoxGrid />


            <section class="space-extra bg-auto-repeat bg-title" data-bg-src={feature_bg_51} style={{ backgroundImage: `url(${feature_bg_51})`, position: 'relative', top: '27px' }}>
                <div class="title-area mb-30  text-center">
                    <h1 className="why-feature_title titlename helvetica" style={{ color: 'white',fontFamily:'helvetica' }} >WHY CHOOSE YUMWAY FOODS</h1>
                </div>

                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ paddingTop:'20PX',paddingBottom:'20PX', paddingLeft: '50px', paddingRight: '50px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px', width: '100%' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    {/* <img src="assets/img/update_2/icon/feature_3_1.svg" alt="Food" /> */}
                                    <img src={quality444} alt="Icon" />
                                </div>
                                <h3 class="food-feature_title box-title text-center" style={{ fontFamily:'helvetica' }}>220 Years of Legacy</h3>
                                <p class="food-feature_text text-white text-center">
                                    Established in 1805 — a heritage of trust in natural food manufacturing.
                                </p>
                                <br />
                                {/* <div className="d-flex justify-content-center">
                                    <Link to={{ pathname: "/about", hash: "#viewmore" }} className="th-btn rounded-2 d-flex align-items-center" style={{ fontFamily:'helvetica',background:"#F0B323"}}>
                                        Read MORE
                                        <i className="fa-solid fa-arrow-right ms-2"></i>
                                    </Link>
                                </div> */}





                                {/* <>
                                    <div className="d-flex justify-content-center">
                                        <button
                                            onClick={() => setShowModal(true)}
                                            className="th-btn rounded-2 d-flex align-items-center"
                                        >
                                            Read MORE
                                            <i className="fa-solid fa-arrow-right ms-2"></i>
                                        </button>
                                    </div>
                                    <br/>
                                    {showModal && (

                                        <div className="modal-bg">
                                        <div className="modal-content">
                                            <span className="close-btn" onClick={() => setShowModal(false)}>
                                                &times;
                                            </span>
                                            <p className='paraPadding'>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
                                                viverra justo nec magna facilisis, sed vestibulum nisl blandit.
                                                Donec eu velit interdum, commodo enim et, tempor nisl.
                                            </p>
                                        </div>
                                    </div>
                                    )}
                                </> */}

                                {/* <div className="d-flex justify-content-center">
                                    <button onClick={scrollToQualitySection} className="th-btn rounded-2 d-flex align-items-center">
                                        Read MORE
                                        <i className="fa-solid fa-arrow-right ms-2"></i>
                                    </button>
                                </div> */}



                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ paddingTop:'20PX',paddingBottom:'20PX', paddingLeft: '50px', paddingRight: '50px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px', width: '100%' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    
                                {/* <img src="assets/img/update_2/icon/feature_3_2.svg" alt="Food" /> */}
                                <img src={custfocus444} alt="Icon" />
                                {/* <img src="assets/img/update_2/icon/sampleicon3.svg" alt="Food" style={{ maxWidth: '26%', maxHeight: '100%' }}/> */}
                                    {/* <img src="assets/img/update_2/icon/featurebgx.svg" alt="Food" style={{ maxWidth: '100%', maxHeight: '100%' }}/> */}
                                </div>
                                <h3 class="food-feature_title box-title text-center" style={{ fontFamily:'helvetica' }}>100% Preservative-Free</h3>
                                <p class="food-feature_text text-white text-center">
                                    Clean-label frozen snacks made with natural preservation techniques.                                     
                                </p>
                                <br />
                                {/* <div className="d-flex justify-content-center">
                                    <Link to={{ pathname: "/about", hash: "#viewmore2" }} className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>
                                        Read MORE
                                        <i className="fa-solid fa-arrow-right ms-2"></i>
                                    </Link>
                                </div> */}


                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ paddingTop:'20PX',paddingBottom:'20PX', paddingLeft: '40px', paddingRight: '40px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px', width: '100%' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    {/* <img src="assets/img/update_2/icon/feature_3_3.svg" alt="Food" /> */}
                                    <img src={techdriven444} alt="Icon" />
                                </div>
                                <h3 class="food-feature_title box-title text-center" style={{ fontFamily:'helvetica' }}>Made from Real Potatoes</h3>
                                <p class="food-feature_text text-white text-center">
                                    Authentic texture and flavour in every fry, wedge, tikki, and hash brown.                                     
                                </p>                                

                                <br />
                                {/* <div className="d-flex justify-content-center">
                                    <Link to={{ pathname: "/about", hash: "#viewmore3" }} className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>
                                        Read MORE
                                        <i className="fa-solid fa-arrow-right ms-2"></i>
                                    </Link>
                                </div> */}

                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="food-feature"
                                style={{ paddingTop:'20PX',paddingBottom:'20PX', paddingLeft: '50px', paddingRight: '50px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px', width: '100%' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    {/* <img src="assets/img/update_2/icon/feature_3_6.svg" alt="Food" style={{ height: "60px" }} /> */}
                                    <img src={backint444} alt="Icon" />
                                </div>
                                <h3 class="food-feature_title box-title text-center" style={{ fontFamily:'helvetica' }}>Export-Ready Range</h3>
                                <p class="food-feature_text text-white text-center">
                                   Trusted by global distributors, QSRs, and hospitality partners.                                      
                                </p>                                 
                                <br />
                                {/* <div className="d-flex justify-content-center">
                                    <Link to={{ pathname: "/about", hash: "#viewmore4" }} className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323"}}>
                                        Read MORE
                                        <i className="fa-solid fa-arrow-right ms-2"></i>
                                    </Link>
                                </div> */}
                            </div>
                        </div>
                        {/* <div class="col-md-3">
                            <div class="food-feature"
                                style={{ padding: '20px', marginBottom: '30px', border: '1px solid #ccc', borderRadius: '10px', width: '100%' }}>
                                <div class="food-feature_icon d-flex justify-content-center align-item-center">
                                    <img src="assets/img/update_2/icon/feature_3_6.svg" alt="Food" style={{ height: "60px" }} />
                                </div>
                            
                             
                                <h3 className="food-feature_title box-title" style={{
                                    whiteSpace: 'nowrap',
                                    '@media (max-width: 768px)': {
                                        whiteSpace: 'normal',
                                        display: 'inline-block',
                                        width: '100%',
                                        padding: '0 10px', 
                                    },
                                    '@media (min-width: 769px) and (max-width: 1100px)': {
                                        whiteSpace: 'normal',
                                        display: 'inline-block',
                                        width: '100%',
                                        padding: '0 10px', 
                                    },
                                    '@media (min-width: 1101px)': {
                                        whiteSpace: 'normal',
                                        display: 'inline-block',
                                        width: '100%',
                                        padding: '0 10px', 
                                    }
                                }}>Backward Integration</h3>


                               
                                <br />
                                <div className="d-flex justify-content-center">
                                <Link to="/Idgnew/about" className="th-btn rounded-2">
                                    Read MORE
                                    <i className="fa-solid fa-arrow-right ms-2"></i>
                                </Link>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>

         
            {/* <section class="position-relative bg-smoke2 pt-5" id="productMenu"
                data-bg-src={menu_bg_5} style={{ backgroundImage: `url(${menu_bg_5})`, position: 'relative', top: '-44px' }}>
                <div class="container">
                    <div class="title-area text-center">
                        <span class="sub-title">Popular Food Menu</span>
                        <h2 class="sec-title">Choose your best menu</h2>
                    </div>
                    <div class="row">
                        <div class="col-xl-4">
                            <div class="food-menu-list">

                                <div class="food-menu">
                                    <div class="food-menu_img">
                                        <img src="assets/img/update_2/menu/menu_2_1.png" alt="Menu" />
                                    </div>
                                    <div class="food-menu_content">
                                        <h3 class="food-menu_title"> <a href="menu.html">Frozen Pud Shrimp</a></h3>
                                        <p class="food-menu_desc">Grilling Churrasco Meat,</p>
                                        <div class="product-rating">
                                            <div class="star-rating" role="img" aria-label="Rated 4.00 out of 5">
                                                <span style={{ width: '75%' }}>Rated <strong class="rating">4.00</strong> out of
                                                    5</span>
                                            </div>
                                            4K Reviews
                                        </div>
                                    </div>
                                    <span class="food-menu_price">$89.39</span>
                                </div>
                                <div class="food-menu">
                                    <div class="food-menu_img">
                                        <img src="assets/img/update_2/menu/menu_2_2.png" alt="Menu" />
                                    </div>
                                    <div class="food-menu_content">
                                        <h3 class="food-menu_title"> <a href="menu.html">Beef Barger</a></h3>
                                        <p class="food-menu_desc">Fresh from the ocean</p>
                                        <div class="product-rating">
                                            <div class="star-rating" role="img" aria-label="Rated 4.00 out of 5">
                                                <span style={{ width: '75%' }}>Rated <strong class="rating">4.00</strong> out of
                                                    5</span>
                                            </div>
                                            4K Reviews
                                        </div>
                                    </div>
                                    <span class="food-menu_price">$79.39</span>
                                </div>
                                <div class="food-menu">
                                    <div class="food-menu_img">
                                        <img src="assets/img/update_2/menu/menu_2_3.png" alt="Menu" />
                                    </div>
                                    <div class="food-menu_content">
                                        <h3 class="food-menu_title"> <a href="menu.html">Chicken Pizza</a></h3>
                                        <p class="food-menu_desc">Japanese cuisine Bowl</p>
                                        <div class="product-rating">
                                            <div class="star-rating" role="img" aria-label="Rated 4.00 out of 5">
                                                <span style={{ width: '75%' }}>Rated <strong class="rating">4.00</strong> out of
                                                    5</span>
                                            </div>
                                            4K Reviews
                                        </div>
                                    </div>
                                    <span class="food-menu_price">$59.39</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4">
                            <div class="menu-image-box">
                                <div class="img1">
                                    <img style={{ width: '400px', height: '20rem' }} src="assets/img/update_2/normal/image_menu.png"
                                        alt="About" />
                                </div>
                                <div class="img2 jump">
                                    <img src="assets/img/update_2/shape/pea_1.png" alt="About" />
                                </div>
                                <div class="discount_style4"  data-bg-src={discount_bg_2} style={{ backgroundImage: `url(${discount_bg_2})`}}>
                                    <p class="small-text">Up to</p>
                                    <h3 class="percentage">32%</h3>
                                    <p class="small-text">discount</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4">
                            <div class="food-menu-list">

                                <div class="food-menu">
                                    <div class="food-menu_img">
                                        <img src="assets/img/update_2/menu/menu_2_4.png" alt="Menu" />
                                    </div>
                                    <div class="food-menu_content">
                                        <h3 class="food-menu_title"> <a href="menu.html">Brief Barger</a></h3>
                                        <p class="food-menu_desc">Grilling Churrasco Meat,</p>
                                        <div class="product-rating">
                                            <div class="star-rating" role="img" aria-label="Rated 4.00 out of 5">
                                                <span style={{ width: '75%' }}>Rated <strong class="rating">4.00</strong> out of
                                                    5</span>
                                            </div>
                                            4K Reviews
                                        </div>
                                    </div>
                                    <span class="food-menu_price">$89.39</span>
                                </div>
                                <div class="food-menu">
                                    <div class="food-menu_img">
                                        <img src="assets/img/update_2/menu/menu_2_5.png" alt="Menu" />
                                    </div>
                                    <div class="food-menu_content">
                                        <h3 class="food-menu_title"> <a href="menu.html">Beef Barbecue</a></h3>
                                        <p class="food-menu_desc">Fresh from the ocean</p>
                                        <div class="product-rating">
                                            <div class="star-rating" role="img" aria-label="Rated 4.00 out of 5">
                                                <span style={{ width: '75%' }}>Rated <strong class="rating">4.00</strong> out of
                                                    5</span>
                                            </div>
                                            4K Reviews
                                        </div>
                                    </div>
                                    <span class="food-menu_price">$79.39</span>
                                </div>
                                <div class="food-menu">
                                    <div class="food-menu_img">
                                        <img src="assets/img/update_2/menu/menu_2_6.png" alt="Menu" />
                                    </div>
                                    <div class="food-menu_content">
                                        <h3 class="food-menu_title"> <a href="menu.html">European</a></h3>
                                        <p class="food-menu_desc">Japanese cuisine Bowl</p>
                                        <div class="product-rating">
                                            <div class="star-rating" role="img" aria-label="Rated 4.00 out of 5">
                                                <span style={{ width: '75%' }}>Rated <strong class="rating">4.00</strong> out of
                                                    5</span>
                                            </div>
                                            4K Reviews
                                        </div>
                                    </div>
                                    <span class="food-menu_price">$59.39</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}





            {/* <section className="mt-3" data-pos-for="#productMenu" data-sec-pos="top-half">
                <div className="container">
                    <div className="booking-area" style={{ backgroundImage: `url(${bookingbg})` }}>
                        <div className="row align-items-center">
                            <div className="col-xl-4 text-center text-xl-start">
                                <div className="title-area mb-25">

                                    <span className="sub-title text-white">Need Help?</span>
                                    <h4 className="sec-title text-white">

                                        Don't Hesitate to contact us for more informations.
                                    </h4>
                                </div>
                                <p className=" text-white mt-n2 mb-n2">

                                </p>
                            </div>
                            <div className="col-xl-8 mt-40 mt-xl-0">
                                <form action="mail.php" method="POST" class="booking-form3">
                                    <div class="row">
                                        <div class="form-group col-lg-6 col-sm-6">
                                            <input type="text" class="form-control rounded-2" id="name" name="name"
                                                placeholder="Name" />

                                        </div>
                                        <div class="form-group col-lg-6 col-sm-6">
                                            <input type="tel" class="form-control rounded-2" id="number" name="number"
                                                placeholder="Phone Number" />
                                            <i class="far fa-phone"></i>
                                        </div>



                                        <div class="form-group col-lg-8 col-sm-6">
                                            <input type="text" class="form-control rounded-2" id="message" name="message"
                                                placeholder="Message" />
                                            <i class="far fa-comment"></i>
                                        </div>
                                        <div class="form-btn col-lg-4 col-sm-6">
                                            <button class="th-btn style5 rounded-2 w-100">Send Message<i
                                                class="fa-solid fa-arrow-right ms-2"></i></button>
                                            <Link to="/Idgnew/contactus" className="th-btn style5 rounded-2 w-100">
                                                Send Message<i className="fa-solid fa-arrow-right ms-2"></i>
                                            </Link>
                                        </div>
                                    </div>
                                    <p class="form-messages mb-0 mt-3"></p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>



            </section> */}

             <section style={{ marginTop: "80px" }}>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-xl-4 text-center text-xl-start">
                            <div class="title-area mb-25">
                                <span class="sub-title" style={{ fontFamily:'helvetica',color:'#F0B323'}}>YUMWAY Across the World</span>
                                <h2 class="sec-title text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138' }}>Taking India's Golden Crisp to Global Tables </h2>
                            </div>
                            <p class="mt-n2 mb-30" style={{ fontFamily:'helvetica' }}>With over 220 years of food legacy, YUMWAY is proudly exporting to markets across the UAE, Saudi Arabia, Qatar, Japan, Israel, Russia, and more. As one of the top frozen French fries exporters from India, we deliver clean-label frozen snacks to global foodservice leaders, distributors, and modern retail shelves.</p>
                            {/* <a href="#" class="th-btn rounded-2">ABOUT MORE<i
                                class="fa-solid fa-arrow-right ms-2"></i></a> */}
                            <Link to="/exports" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:"#F0B323" }}>
                                Become a Country Partner
                                <i className="fa-solid fa-arrow-right ms-2"></i>
                            </Link>
                        </div>
                        <div class="col-xl-8 mt-40 mt-xl-0">
                            <div class="row gy-4 justify-content-center">
                                <div class="col-lg-4 col-sm-6">
                                    <div class="why-feature" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                                        <div class="why-feature_icon">
                                            <img src="assets/img/update_2/icon/qahome111.svg" alt="icon" />
                                        </div>
                                        <h3 class="why-feature_title" style={{ fontFamily:'helvetica',color:'#0f1138' }}>Quality Assurance</h3>
                                        <p class="why-feature_text" style={{ fontFamily:'helvetica' }}>
                                            Our state-of-the-art factory ensures that each product meets the highest standards of safety, reliability, and quality.</p>

                                    </div>
                                </div>
                                <div class="col-lg-4 col-sm-6">
                                    <div class="why-feature">
                                        <div class="why-feature_icon">
                                            <img src="assets/img/update_2/icon/custcentric111.svg" alt="icon" />
                                        </div>
                                        <h3 class="why-feature_title" style={{ fontFamily:'helvetica',color:'#0f1138' }}>Customer-Centric Approach</h3>
                                        <p class="why-feature_text" style={{ fontFamily:'helvetica' }}>
                                            With a focus on building long-term relationships, we prioritize customer satisfaction above all.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-sm-6">
                                    <div class="why-feature">
                                        <div class="why-feature_icon">
                                            <img src="assets/img/update_2/icon/expertinfra111.svg" alt="icon" />
                                        </div>
                                        <h3 class="why-feature_title" style={{ fontFamily:'helvetica',color:'#0f1138' }}>Expertise & Infrastructure</h3>
                                        <p class="why-feature_text" style={{ fontFamily:'helvetica' }}>With over 200 years of experience in the food and FMCG
                                            industry through GRKC Group.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </section>
            
            {/* <section className="overflow-hidden space">

                <div class="container">
                    <div class="row">
                        <div class="col-xl-6">
                            <div class="pe-xxl-5">
                                <div className="title-area mb-0 text-center text-xl-start">
                                    <span className="sub-title">Testimonials</span>
                                    <h2 className="sec-title">What customer saying About Services</h2>
                                </div>
                            </div>
                            <div className="testi-card-slide">
                                <div className="row th-carousel number-dots" data-slide-show="1" data-lg-slide-show="2"
                                    data-md-slide-show="1" data-dots="true" data-xl-dots="true" data-ml-dots="true"
                                    data-lg-dots="true" data-md-dots="true">
                                        
                                    <Slider {...settingstestimonal}>
                                        <div>
                                            <p>
                                              
                                                <div class="testi-block">
                                                    <div class="testi-block_shape">
                                                        <img src={testiblock_bg} alt="BG" />
                                                    </div>
                                                    <div class="testi-block_profile">
                                                        <div class="testi-block_avater">
                                                            <img src={testi_4_1} alt="Avater" />
                                                            <div class="testi-block_quote">
                                                                <img src={quote_1} alt="Icon" />
                                                            </div>
                                                        </div>
                                                        <div class="media-body">
                                                            <div class="testi-block_review">
                                                                <i class="fa-sharp fa-solid fa-star"></i><i
                                                                    class="fa-sharp fa-solid fa-star"></i><i
                                                                        class="fa-sharp fa-solid fa-star"></i><i
                                                                            class="fa-sharp fa-solid fa-star"></i><i
                                                                                class="fa-sharp fa-solid fa-star"></i>
                                                            </div>
                                                            <h3 class="testi-block_name">Rayan Kook</h3>
                                                            <span class="testi-block_desig">NYC, USA</span>
                                                        </div>
                                                    </div>
                                                    <p class="testi-block_text">As a passionate restaurant owner, ensuring that our dishes delight our customers is paramount. IDG has been our steadfast partner for sourcing top-quality Indian shrimps, a key ingredient in many of our signature dishes. Their consistent excellence in providing shrimps of perfect size, flavor, and texture has been instrumental in maintaining our reputation for culinary excellence.</p>
                                                </div>
                                            </p>


                                        </div>
                                        <div>
                                            <p>
                                              
                                                <div class="testi-block">
                                                    <div class="testi-block_shape">
                                                        <img src={testiblock_bg} alt="BG" />
                                                    </div>
                                                    <div class="testi-block_profile">
                                                        <div class="testi-block_avater">
                                                            <img src={testi_4_2} alt="Avater" />
                                                            <div class="testi-block_quote">
                                                                <img src={quote_1} alt="Icon" />
                                                            </div>
                                                        </div>
                                                        <div class="media-body">
                                                            <div class="testi-block_review">
                                                                <i class="fa-sharp fa-solid fa-star"></i><i
                                                                    class="fa-sharp fa-solid fa-star"></i><i
                                                                        class="fa-sharp fa-solid fa-star"></i><i
                                                                            class="fa-sharp fa-solid fa-star"></i><i
                                                                                class="fa-sharp fa-solid fa-star"></i>
                                                            </div>
                                                            <h3 class="testi-block_name">Michel Clark</h3>
                                                            <span class="testi-block_desig">DYM, USA</span>
                                                        </div>
                                                    </div>
                                                    <p class="testi-block_text"> IDG's commitment to sustainable practices is what sets them apart in the competitive seafood market. As a consumer conscious of environmental impact, knowing that I'm purchasing ethically sourced Indian shrimps from IDG gives me peace of mind.</p>

                                                </div>
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                               
                                                <div class="testi-block">
                                                    <div class="testi-block_shape">
                                                        <img src={testiblock_bg} alt="BG" />
                                                    </div>
                                                    <div class="testi-block_profile">
                                                        <div class="testi-block_avater">
                                                            <img src={testi_4_3} alt="Avater" />
                                                            <div class="testi-block_quote">
                                                                <img src={quote_1} alt="Icon" />
                                                            </div>
                                                        </div>
                                                        <div class="media-body">
                                                            <div class="testi-block_review">
                                                                <i class="fa-sharp fa-solid fa-star"></i><i
                                                                    class="fa-sharp fa-solid fa-star"></i><i
                                                                        class="fa-sharp fa-solid fa-star"></i><i
                                                                            class="fa-sharp fa-solid fa-star"></i><i
                                                                                class="fa-sharp fa-solid fa-star"></i>
                                                            </div>
                                                            <h3 class="testi-block_name">Rosse Mons</h3>
                                                            <span class="testi-block_desig">DO, USA</span>
                                                        </div>
                                                    </div>
                                                    <p class="testi-block_text">Commitment to quality, reliability, and sustainability is unmatched. We've been consistently impressed with the freshness and taste of their Indian shrimps, and their seamless logistics ensure timely deliveries every time.</p>
                                                </div>
                                            </p>
                                        </div>
                                    </Slider>

                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 mt- mt-xl-0">
                            <div class="testi-card-img">
                                <div class="img1">
                                    <img src={testicardimg} alt="Image" />
                                </div>
                                <div class="shape1">
                                    <img src={testicardshape} alt="Image" />
                                </div>
                                <div class="shape2">
                                    <img src="assets/img/update_2/normal/testi-card_shape_2.png" alt="Image" />
                                </div>
                                <div class="shape3">
                                    <img src="assets/img/update_2/normal/testi-card_shape_3.png" alt="Image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <br />*
            <br />
            <br />
            <br />
            <br />
            <section className="overflow-hidden space" style={{ marginTop: '-50px', padding: '20px' }}>
                <div class="title-area mb-30  text-center">
                    <h1 className="why-feature_title titlename text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138'}}>OUR CERTIFICATIONS</h1>
                </div>
                {/* <div class="container"> */}
                    {/* <Slider {...settingstwice}>
                        <div style={{ border: '0px solid #eb2e2e', display: 'inline-block', padding: '26px', borderRadius: '10px' }}>
                            <img className="gray" src={certifications6} alt="Brand Logo" />
                        </div>
                        <div style={{ border: '0px solid #eb2e2e', display: 'inline-block', padding: '26px', borderRadius: '10px' }}>
                            <img className="gray" src={certifications4} alt="Brand Logo" />
                        </div>
                    </Slider> */}

                {/* <div className='certdiv' style={{ border: '0px solid #eb2e2e', display: 'inline-block',  borderRadius: '10px' }}>
                    <img className="gray" src={certificationsSINGLE} alt="Brand Logo" />
                </div>                     */}
                {/* </div> */}
                <div class="container">
                    <div class="row th-carousel" data-slide-show="6" data-ml-slide-show="5" data-lg-slide-show="4"
                        data-md-slide-show="3" data-sm-slide-show="2" data-xs-slide-show="2">
                        <Slider {...settingsscroll11}>
                            {CertificatImg.map((img, index) => (

                                <div class="col-xl-2 col-lg-3 col-md-3 col-sm2" key={index}>
                                {/* <div class="col-xl-2 col-lg-3 col-md-3 col-sm2" key={index}> */}
                                    <div class="category-border category-border1 py-0">
                                        <div class="category-border_img my-0">
                                            <Link to="#" className="">
                                                {/* <img src={img} alt="Image" style={{ height: '290px' }} /> */}
                                                <img src={img} alt="Image"  />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}

 
                        </Slider>
                    </div>
                </div>
            </section>
            <br /><br /><br />
            <section class="space-bottom contact-form-sec mt-0" style={{display:'none'}}>
                <div class="container">
                    <div class="reservation-area"style={{ backgroundImage: `url(${feature_bg_51})`, position: 'relative', top: '27px' }}>
                        <h4 class="sec-title text-center mb-30" style={{ fontFamily:'helvetica',color:'#ffffff',textTransform: 'uppercase' }}>Become A Country Partner</h4>
                        <form action="mail.php" method="POST" class="booking-form3 ajax-contact" style={{ fontFamily:'helvetica' }}>
                            <div class="row">
                                <div class="form-group col-lg-4 col-md-6">
                                    <input type="text" class="form-control rounded-2" id="name" name="name"
                                        placeholder="Your Name" style={{ fontFamily:'helvetica' }}/>
                                    <i class="far fa-user" style={{color:'#F0B323'}}></i>
                                </div>
                                <div class="form-group col-lg-4 col-md-6">
                                    <input type="tel" class="form-control rounded-2" id="number" name="number"
                                        placeholder="Phone Number" style={{ fontFamily:'helvetica' }} />
                                    <i class="far fa-phone" style={{color:'#F0B323'}}></i>
                                </div>
                                <div class="form-group col-lg-4">
                                    <input type="text" class="form-control rounded-2" id="subject" name="subject"
                                        placeholder="Subject" style={{ fontFamily:'helvetica' }}/>
                                    <i class="far fa-tag" style={{color:'#F0B323'}}></i>
                                </div>
                                <div class="form-group col-12">
                                    <textarea name="message" id="message" cols="30" rows="3" class="form-control rounded-2"
                                        placeholder="Write Message" style={{ fontFamily:'helvetica' }}></textarea>
                                    <i class="far fa-comment" style={{color:'#F0B323'}}></i>
                                </div>
                            </div>
                            {/* <div class="form-btn text-center">
                        <button class="th-btn rounded-2">Send Message<i
                                class="fa-solid fa-arrow-right ms-2"></i></button>
                    </div> */}
                            <div className="text-center">
                                <Link to="/" className="th-btn rounded-2" style={{ fontFamily:'helvetica',background:'#F0B323' }}>Send Message<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                            </div>
                            <p class="form-messages mb-0 mt-3"></p>
                        </form>
                    </div>
                </div>
            </section>  
            <section className="overflow-hidden space" style={{ marginTop: '-50px', padding: '20px' }}>
                <div class="title-area mb-30  text-center">
                    <h1 className="why-feature_title titlename text-uppercase" style={{ fontFamily:'helvetica',color:'#0f1138'}}>Visual Journey Through Our Events</h1>
                </div>
                <div class="container">
                    <div class="row th-carousel" data-slide-show="6" data-ml-slide-show="5" data-lg-slide-show="4"
                        data-md-slide-show="3" data-sm-slide-show="2" data-xs-slide-show="2">
                        <Slider {...settingsscroll}>
                            {SliderImg.map((img, index) => (

                                <div class="col-xl-2 col-lg-3 col-md-3 col-sm2" key={index}>
                                {/* <div class="col-xl-2 col-lg-3 col-md-3 col-sm2" key={index}> */}
                                    <div class="category-border">
                                        <div class="category-border_img">
                                            <Link to="#" className="">
                                                {/* <img src={img} alt="Image" style={{ height: '290px' }} /> */}
                                                <img src={img} alt="Image"  />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}

 
                        </Slider>
                    </div>
                </div>

            </section>             


            <Footer  homepage/>
            <style jsx>
                {`
                    div.certdiv{
                        padding:26px;
                    }
                    @media (max-width: 767px) {
                        div.certdiv{
                            padding:0px;
                        }
                    }   
                    .category-border1:hover {
                        border: none;
                    }  
                    .category-border1 .category-border_img{
                        // border: 1px solid #f0b323;
                        // background-color:#f2f2f2;
                    } 
                    .category-border1 .category-border_img:hover{
                        background-color: #fff2d2;
                    }                                                                                         
                `}
            </style>
        </div>
    );
};

export default Homepage;
